/**
 * @generated SignedSource<<f2a7064cc8152c7d35d26762b566730d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutDeposit_transaction$data = {
  readonly buyer: {
    readonly serviceId: string | null;
  } | null;
  readonly isDepositAvailable: boolean;
  readonly item: {
    readonly serviceId: string | null;
  } | null;
  readonly " $fragmentType": "CheckoutDeposit_transaction";
};
export type CheckoutDeposit_transaction$key = {
  readonly " $data"?: CheckoutDeposit_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeposit_transaction">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "serviceId",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutDeposit_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDepositAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "buyer",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};
})();

(node as any).hash = "67665a145e5403b6d727c0dad6c777cf";

export default node;
